import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { isNullOrUndefined } from '../../../utils/general'

export default class InputTextField extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    fieldName: PropTypes.string,
    fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    required: PropTypes.bool.isRequired,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func.isRequired,
    fieldOnlyBoolean: PropTypes.bool,
    readOnly: PropTypes.bool
  }

  render() {
    return (
      <div className="group">
        {!this.props.fieldOnlyBoolean ? (
          <label className={`header ${this.props.error ? 'error' : ''}`} htmlFor={this.props.fieldName}>
            {this.props.name ? this.props.name : null}
            {this.props.required ? '*' : null}
          </label>
        ) : null}
        <div className="input-wrapper">
          <input
            className={`input-field ${this.props.error ? 'error' : ''}`}
            value={!isNullOrUndefined(this.props.fieldValue) ? this.props.fieldValue : ''}
            onChange={this.handleChange}
            id={this.props.fieldName}
            disabled={this.props.readOnly === true}
          />
        </div>
        {this.props.error && typeof this.props.error === 'string' && (
          <div className="input-error-message">{this.props.error}</div>
        )}
      </div>
    )
  }

  handleChange = event => {
    this.props.onChange(event.target.value, this.props.fieldName)
  }
}
